import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Jobs() {
    return (
        <Default>
            <Head>
                <title>Algemene voorwaarden</title>
                <link rel="canonical" href={route("terms")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Algemene voorwaarden - WE ARE Personal Training Uden en Schijndel Uden &amp; Scijndel"
                />
                <meta
                    property="og:description"
                    content="Algemene voorwaarden - WE ARE Personal Training Uden en Schijndel Uden &amp; Scijndel"
                />
                <meta property="og:url" content={route("terms")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Algemene voorwaarden - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl sm:text-7xl">
                        Algemene voorwaarden
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="requirements"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Meer informatie
                        </Link>
                    </div>
                </Hero> */}

                <div className="relative p-32" id="requirements">
                    <div className="max-w-5xl mx-auto">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 1: Begripsbepaling
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                <b>Opdrachtnemer/WE ARE</b>: We Are Uden B.V.,
                                gevestigd te Uden aan de Walterus Pijnenborghhof
                                8A (5401 XT), geregistreerd onder nummer
                                83938141 bij de Kamer van Koophan- del en/of We
                                Are Schijndel B.V., gevestigd te Schijndel aan
                                de Spoorlaan 18 D (5481 SK), geregistreerd onder
                                nummer 84447532 bij de Kamer ven Koophandel;
                            </li>
                            <li className="text-gray-100">
                                <b>Opdrachtgever/klant</b>: de natuurlijke of
                                rechtspersoon die een overeenkomst met We Are
                                Uden B.V. is aangegaan met betrekking tot door
                                We Are Uden B.V. te leveren diensten en/of
                                producten;
                            </li>
                            <li className="text-gray-100">
                                <b>Consument</b>: de Opdrachtgever die niet
                                handelt in de uitoefening van zijn beroep of
                                bedrijf;
                            </li>
                            <li className="text-gray-100">
                                <b>Overeenkomsten</b>: alle aanbiedingen,
                                opdrachten, overeenkomsten en verbintenissen hoe
                                ook genaamd, van We Are Uden B.V. met
                                Opdrachtgever, alsmede de uitvoering daarvan;
                            </li>
                            <li className="text-gray-100">
                                <b>Diensten</b>: verzamelnaam voor alle diensten
                                te verrichten door We Are Uden B.V.;
                            </li>
                            <li className="text-gray-100">
                                <b>Prijzen</b>: prijzen van diensten en/of van
                                producten;
                            </li>
                            <li className="text-gray-100">
                                <b>Schriftelijk</b>: ook elektronische
                                communicatie zoals e-mail en andere vormen van
                                dataverkeer, mits de identiteit van de afzender
                                en de authenticiteit van de communicatie
                                voldoende vaststaat.
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 2: Algemene voorwaarden
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                Deze algemene voorwaarden zijn van toepassing op
                                alle aanbiedingen, werkzaamheden, offertes en
                                overeenkomsten voor dienstverlening tussen WE
                                ARE en de klant en hun rechtsop- volgers.
                            </li>
                            <li className="text-gray-100">
                                Afwijkingen van deze algemene voorwaarden zijn
                                slechts geldig indien schriftelijk
                                overeengekomen.
                            </li>
                            <li className="text-gray-100">
                                De toepasselijkheid van de artikelen 7:404 en
                                7:407 lid 2 en 7:409 van het Burgerlijk Wetboek
                                is uitgesloten.
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 3: Aanmelding
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                Bij aanmelding ontvangt de klant een (online)
                                intakeformulier. Dit dient de klant volledig in
                                te vullen en te submitten/retourneren.
                            </li>
                            <li className="text-gray-100">
                                WE ARE is gerechtigd om de aangeleverde gegevens
                                te gebruiken t.b.v. de communicatie met leden.
                            </li>
                            <li className="text-gray-100">
                                Als het maximum aantal klanten is bereikt (35
                                personen) wordt de klant met wederzijdse
                                instemming op de wachtlijst geplaatst en wordt
                                gebeld wanneer er een plek vrij is gekomen.
                            </li>
                            <li className="text-gray-100">
                                Om deel te nemen dient de klant akkoord te geven
                                op de algemene voorwaarden
                            </li>
                            <li className="text-gray-100">
                                Personen jonger dan 18 jaar zijn verplicht om
                                een handtekening door één van de wettelijke
                                vertegenwoordigers te laten zetten.
                            </li>
                            <li className="text-gray-100">
                                Wanneer de klant een overeenkomst sluit voor het
                                Open Gym, stelt WE ARE daarvoor een druppel ter
                                beschikking. Voor die druppel wordt eenmalig €
                                25 in rekening gebracht. Na het einde van het
                                abonnement ontvangt de klant die de druppel weer
                                inlevert de betaalde borg re- tour. Bij verlies
                                of diefstal van de druppel dient het lid een
                                nieuwe druppel aan te schaffen en wordt € 25 in
                                rekening gebracht.s
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 4: Overeenkomst en duur
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                WE ARE kent die typen programma's:
                                <ol className="pt-4 list-[upper-latin]">
                                    <li className="text-gray-100">
                                        Personal Training, DUO training en Small
                                        Group: Een leefstijl programma van
                                        minimaal 12 weken waarin voeding,
                                        training, slaap en stress centraal
                                        staan. Het lid wordt begeleid door een
                                        vaste coach gedurende de tijd dat het
                                        lid in een van deze vormen traint. Het
                                        lid traint minimaal twee keer per week
                                        en maximaal vier keer per week.
                                    </li>
                                    <li className="text-gray-100">
                                        Open gym: Het lid kan overstappen naar
                                        de open gym wanneer de training als
                                        bedoeld in artikel 4 lid 1 sub a is
                                        afgerond. Het lid met een abonnement op
                                        de open gym kan onbeperkt vrij trainen
                                        bij WE ARE.
                                    </li>
                                    <li className="text-gray-100">
                                        Jaarprogramma: Het lid neemt gedurende
                                        de eerste twaalf weken deel aan het
                                        jaar- programma en wordt intensief
                                        begeleid door een vaste coach. Na
                                        ommekomst van de 12 weken vervolgt het
                                        lid zijn training gedurende 40 weken in
                                        het open gym.
                                    </li>
                                </ol>
                            </li>
                            <li className="text-gray-100">
                                De klant gaat een overeenkomst aan met WE ARE
                                voor Personal Training, DUO training en Small
                                Group voor de duur van twaalf weken. Na
                                ommekomst van deze periode eindigt de
                                overeenkomst van rechtswege, doch kan de
                                overeenkomst voor een nader overeen te komen
                                termijn worden verlengd.
                            </li>
                            <li className="text-gray-100">
                                WE ARE hanteert twee typen abonnementen:
                                <ol className="pt-4 list-[upper-latin]">
                                    <li className="text-gray-100">
                                        een abonnement voor een vast bedrag per
                                        maand wat maandelijks opzegbaar is, met
                                        een opzegtermijn van één maand;
                                    </li>
                                    <li className="text-gray-100">
                                        een abonnement voor een ander vast
                                        bedrag per maand wat een looptijd kent
                                        van één jaar, en wat na ommekomst van
                                        dat jaar maandelijks opzegbaar wordt met
                                        een opzegtermijn van één maand.
                                    </li>
                                </ol>
                            </li>
                            <li className="text-gray-100">
                                Wanneer een abonnement als bedoeld in lid 3 sub
                                b van dit artikel wordt aangegaan wordt die
                                overeenkomst telkens stilzwijgend verlengd voor
                                de duur van één jaar, tot wederopzegging. De
                                overeenkomst kan na ommekomst van het eerste
                                jaar maandelijks worden opgezegd met
                                inachtneming van een opzegtermijn van één maand
                            </li>
                        </ol>
                    </div>
                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 5: Betalingsvoorwaarden
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                Het abonnementsgeld wordt gefactureerd in EUR en
                                is exclusief BTW tenzij de klant een particulier
                                is (die niet handelt in de uitoefening van zijn
                                beroep of bedrijf).
                            </li>
                            <li className="text-gray-100">
                                WE ARE factureert het abonnementsgeld per vier
                                weken, tenzij de klant vooraf heeft aangegeven
                                de prijs voor een bepaalde periode ineens te
                                willen voldoen.
                            </li>
                            <li className="text-gray-100">
                                Wanneer de klant een machtiging voor
                                automatische incasso heeft afgegeven incasseert
                                WE ARE vier-wekelijks, tussen de 1e en de 10e
                                van de maand. Het bedrag wordt automatisch
                                afgeschreven op de datum die op de
                                vooraankondiging staat vermeld.
                            </li>
                            <li className="text-gray-100">
                                Bij een niet- of niet-tijdige betaling van een
                                opeisbare factuur of een mislukte
                                incasso-opdracht volgen twee
                                betalingsherinneringen. Na de tweede
                                betalingsherinnering treedt het verzuim in en is
                                de klant een rente van 1% per maand verschuldigd
                                over het openstaande factuurbedrag en
                                buitengerechtelijke incassokosten van 10% met
                                een minimum van €150.
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 6: Aansprakelijkheid
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                De klant dient zich te allen tijde te houden aan
                                de gegeven instructies van WE ARE en deze
                                zorgvuldig op te volgen.
                            </li>
                            <li className="text-gray-100">
                                WE ARE is niet verantwoordelijk voor
                                persoonlijke ongevallen of letsel en eventueel
                                daaruit voortvloeiende schade, noch voor
                                diefstal of beschadiging van goederen van de
                                klant, binnen noch buiten de locatie van WE ARE,
                                al dan niet onder begeleiding van een
                                instructeur van WE ARE.
                            </li>
                            <li className="text-gray-100">
                                Wanneer de klant tijdens de training pijn of
                                andere klachten ervaart dient hij de training
                                on- middellijk te staken en WE ARE (desgevraagd
                                en ongevraagd) in te lichten over het bestaan
                                (en niet de inhoud) van de klachten.
                            </li>
                            <li className="text-gray-100">
                                WE ARE heeft een inspanningsverplichting en geen
                                resultaatverplichting. WE ARE is dus niet
                                verantwoordelijk voor de niet-behaalde
                                doelstellingen van de klant. De afspraken die
                                zijn ge- maakt met WE ARE over voedings- en
                                trainingsadviezen, zijn gemaakt om lichamelijke
                                gezondheid van de klant te verbeteren. De klant
                                blijft echter zelf verantwoordelijk voor het
                                beha- len van resultaten.
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 7: Annulering training
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                De klant reserveert een trainingstijd in overleg
                                met zijn of haar trainer. Annuleringen van trai-
                                ningen vanuit de klant wegens ziekte en/of
                                andere omstandigheden dienen uiterlijk 12 uur
                                voor aanvang van de training telefonisch kenbaar
                                te worden gemaakt aan één van de trainers. Een
                                afmelding via WhatsApp is niet geldig.
                            </li>
                            <li className="text-gray-100">
                                Indien tijdig op de voorgeschreven wijze is
                                afgemeld, wordt in overleg de training en/of
                                behandeling opnieuw ingepland. Er worden
                                maximaal vier trainingen ingehaald, vanaf de
                                vijfde afgemelde training wordt de training
                                geacht te vervallen, behoudens specifieke
                                gevallen, zulks telkens ter beoordeling aan WE
                                ARE.
                            </li>
                            <li className="text-gray-100">
                                De gemiste training wordt volledig in rekening
                                gebracht bij de klant. Indien tijdig en op de
                                voorgeschreven wijze is afgemeld kan de klant de
                                gemiste training op een later moment inhalen.
                            </li>
                            <li className="text-gray-100">
                                Annuleringen van afspraken voor een gedurende
                                langere tijd zoals vakantie dienen twee weken
                                voorafgaand aan de afwezige periode via de mail
                                kenbaar te worden gemaakt bij de trainer.
                                <ol className="pt-4 list-[upper-latin]">
                                    <li className="text-gray-100">
                                        Wanneer de klant een doorlopend
                                        (jaar)abonnement heeft loopt dit
                                        abonnement onverkort door, ook wanneer
                                        de klant er geen gebruik van maakt, tot
                                        wederopzegging.
                                    </li>
                                    <li className="text-gray-100">
                                        Indien de klant tijdens een twaalf weken
                                        durend programma meer dan twee weken
                                        gepland afwezig is dan is het dringend
                                        doch vrijblijvend advies van WE ARE om
                                        later aan te vangen met het twaalf weken
                                        programma.
                                    </li>
                                </ol>
                            </li>
                            <li className="text-gray-100">
                                Trainingen en behandelingen worden geannuleerd
                                wanneer de klant minimaal 15 minuten te laat is
                                voor de training, zonder geldige reden. Bij het
                                zonder geldige reden te laat komen van de klant
                                wordt de training in rekening gebracht bij de
                                klant.
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 8: Overmacht
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                Partijen zijn niet gehouden tot het nakomen van
                                enige verplichting, indien zij daartoe gehin-
                                derd worden als gevolg van een omstandigheid die
                                niet is te wijten aan schuld, en noch krach-
                                tens de wet, een rechtshandeling of in het
                                verkeer geldende opvattingen voor hun rekening
                                komt.
                            </li>
                            <li className="text-gray-100">
                                Onder overmacht wordt in deze algemene
                                voorwaarden in ieder geval begrepen (doch niet
                                beperkt tot): (dreiging van) oorlog,
                                oorlogsgevaar, burgeroorlog, oproer, onlusten,
                                terrorisme, werkstaking, bedrijfsbezetting,
                                uitsluiting, brand, milieu- en waterschade,
                                overstroming, over- heidsmaatregelen, storingen
                                in de levering van energie en
                                bedrijfsbenodigdheden, bouwstop,
                                onbeschikbaarheid van hulppersonen of apparaten,
                                plotselinge arbeidsongeschiktheid van
                                werknemers, storingen in het computernetwerk,
                                onwerkbare dagen, werkstaking, onwerkbaar weer
                                (zulks ter beoordeling van WE ARE), epidemie
                                en/of pandemie en overige gebeurtenis- sen die
                                kunnen leiden tot stagnatie in de geregelde gang
                                van zaken binnen een onderneming en die niet in
                                redelijkheid voor rekening of risico komen van
                                WE ARE, worden die verplichtin- gen opgeschort
                                tot het moment dat WE ARE alsnog in staat is op
                                de overeengekomen wijze na te komen, zonder dat
                                WE ARE in verzuim raakt ten aanzien van de
                                nakoming van haar verplichtingen en zonder dat
                                zij tot enige schadevergoeding kan worden
                                gehouden.
                            </li>
                            <li className="text-gray-100">
                                WE ARE heeft ook het recht zich op overmacht te
                                beroepen indien de omstandigheid die (verdere)
                                nakoming verhindert, intreedt nadat WE ARE haar
                                verbintenis had moeten nako- men.
                            </li>
                            <li className="text-gray-100">
                                Partijen kunnen gedurende de periode dat de
                                overmacht voortduurt de verplichtingen uit de
                                overeenkomst opschorten. Indien deze periode
                                langer duurt dan twee maanden is ieder der
                                partijen gerechtigd de overeenkomst te
                                ontbinden, zonder verplichting tot vergoeding
                                van schade aan de andere partij.
                            </li>
                            <li className="text-gray-100">
                                Voor zover WE ARE ten tijde van het intreden van
                                overmacht inmiddels gedeeltelijk haar
                                verplichtingen uit de overeenkomst is nagekomen
                                of deze zal kunnen nakomen, dan heeft WE ARE
                                aanspraak op:
                                <ol className="pt-4 list-[upper-latin]">
                                    <li className="text-gray-100">
                                        een vergoeding van de in de overeenkomst
                                        vastgelegde prijs, berekend naar het
                                        verloop van tijd op het moment van
                                        ontbinding of opzegging en
                                    </li>
                                    <li className="text-gray-100">
                                        een vergoeding van alle gemaakte en nog
                                        te maken kosten, voortvloeiend uit
                                        verplichtin- gen die WE ARE op het
                                        tijdstip van ontbinding of opzegging
                                        reeds is aangegaan met het oog op de
                                        uitvoering van de overeenkomst en die op
                                        grond daarvan voor rekening komen van de
                                        klant.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 9: Opschorting en beëindiging overeenkomst
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                WE ARE is bevoegd de nakoming van haar
                                verplichtingen op te schorten of de overeenkomst
                                te ontbinden, indien:
                                <ol className="pt-4 list-[upper-latin]">
                                    <li className="text-gray-100">
                                        de klant de verplichtingen uit de
                                        overeenkomst niet of niet volledig
                                        nakomt;
                                    </li>
                                    <li className="text-gray-100">
                                        na het sluiten van de overeenkomst WE
                                        ARE ter kennis gekomen omstandigheden
                                        goe- de grond geven te vrezen dat de
                                        klant de verplichtingen niet zal
                                        nakomen. In geval er goede grond bestaat
                                        te vrezen dat de klant slechts
                                        gedeeltelijk of niet behoorlijk zal
                                        nakomen, is de opschorting slechts
                                        toegelaten voor zover de tekortkoming
                                        haar rechtvaar- digt.
                                    </li>
                                    <li className="text-gray-100">
                                        Voorts is WE ARE bevoegd de overeenkomst
                                        te (doen) ontbinden indien zich
                                        omstandigheden voordoen die van dien
                                        aard zijn dat nakoming van de
                                        overeenkomst onmogelijk is of naar
                                        maatstaven van redelijkheid en
                                        billijkheid niet langer kan worden
                                        gevergd dan wel indien zich anderszins
                                        omstandigheden voordoen die van dien
                                        aard zijn dat on- gewijzigde
                                        instandhouding van de overeenkomst in
                                        redelijkheid niet mag worden verwacht.
                                    </li>
                                </ol>
                            </li>
                            <li className="text-gray-100">
                                Wanneer een vrouwelijke klant gedurende de
                                looptijd van de overeenkomst door zwangerschap
                                of bevalling niet (langer) kan deelnemen aan de
                                training heeft zij de mogelijkheid om de
                                trainingen op een later, in overleg te bepalen
                                moment in te halen. De periodieke betalingen
                                lopen wel door.
                            </li>
                            <li className="text-gray-100">
                                De overeenkomst is niet tussentijds opzegbaar,
                                behoudens in de volgende gevallen:
                                <ol className="pt-4 list-[upper-latin]">
                                    <li className="text-gray-100">
                                        als bedoeld in artikel 4 lid 4 van deze
                                        algemene voorwaarden of
                                    </li>
                                    <li className="text-gray-100">
                                        in geval van een blessure waardoor de
                                        klant op doktersadvies naar verwachting
                                        niet binnen zes maanden weer gebruik zal
                                        kunnen maken van de diensten van WE ARE.
                                    </li>
                                </ol>
                            </li>
                            <li className="text-gray-100">
                                Wanneer de klant de overeenkomst tussentijds
                                opzegt en geen sprake is van de redenen zoals
                                bedoeld in het vorige lid is de klant het
                                volledige abonnementsgeld verschuldigd voor de
                                resterende looptijd van de overeenkomst.
                            </li>
                            <li className="text-gray-100">
                                WE ARE behoudt zich het recht voor om bij
                                ernstige of herhaaldelijke schending van de
                                normale fatsoensregels of ander onaanvaardbaar
                                gedrag het traject stop te zetten, waarbij het
                                resterende abonnementsgeld onverkort
                                verschuldigd blijft.
                            </li>
                        </ol>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Artikel 10: Geschillen
                        </h2>
                        <ol className="pt-4 list-decimal">
                            <li className="text-gray-100">
                                Op elke Overeenkomst tussen WE ARE en de klant
                                is Nederlands recht van toepassing. Het Weens
                                Koopverdrag is uitdrukkelijk uitgesloten.
                            </li>
                            <li className="text-gray-100">
                                De Nederlandse rechter is bevoegd kennis te
                                nemen van geschillen uit hoofde van de
                                overeenkomst en/of de algemene voorwaarden.
                            </li>
                        </ol>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
